import React, { useState, useEffect } from 'react';

import { AlertMessage } from "components";

import { func_validation, isStringTrimNotEmpty } from "functions";
import { Toaster } from 'components/notification/Toaster';
import { useCustomSelector } from 'hooks';

export function useAlertMessage(props) {
    const { 
        isFormSubmissionAttempted,
    } = props;

    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);
    const { addAccount_errorMsg } = useCustomSelector("recursiveBillingSetup");

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addAccount_errorMsg);
    }, [addAccount_errorMsg]);

    let alertMessageDisplay = isAlertMsgVisible? (
        <div className={"pb-3"}>
            <AlertMessage
                message={alertMsg}
                isVisible={isAlertMsgVisible}
                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
            />
        </div>
    ):"";

    return {
        alertMessageDisplay
    };
}